import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex items-center flex-wrap" }
const _hoisted_3 = { class: "flex items-center order-last flex-shrink-0 w-full lg:flex-shrink lg:order-none lg:w-min" }
const _hoisted_4 = { class: "leading-snug" }
const _hoisted_5 = { class: "leading-snug" }
const _hoisted_6 = { class: "mb-4 flex items-center cursor-pointer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-dark-gray font-bold" }, " Pobierz fakturę", -1)
const _hoisted_8 = { class: "grid grid-cols-2 text-sm font-basier lg:grid-cols-3 lg:gap-x-6 lg:text-base" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = { class: "ml-1" }
const _hoisted_11 = { class: "block" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "ml-1" }
const _hoisted_14 = { class: "block" }
const _hoisted_15 = { class: "block font-bold" }
const _hoisted_16 = { class: "block" }

import router from '@/router'
import {
    UiCard,
    UiTitle,
    UiDropdownMenu,
    UiMenuDots,
    UiDotDivider,
    UiCardText,
    UiCardIconText,
    UiCheckbox,
    UiButton,
} from '@/components/common/ui'
import { computed } from 'vue'
import { Advice } from '@/composables/useAdvices'
import { useAdviceDocuments, InvoiceFormModes } from '@/composables/useAdviceDocuments'
import { useInvoices } from '@/composables/useInvoices'
import AdviceStatusLabel from './AdviceStatusLabel.vue'
import { useNotifications } from '@/composables/useNotifications'
import { IDropdownMenuItem } from '@/types/interfaces/dropdownMenu'

type Props = {
    advice: Advice
}
interface IEventAdvicesListItem {
    (e: 'fetchAdvices'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    advice: { type: null, required: true }
  },
  emits: ["fetchAdvices"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'fetchAdvices'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    advice: Advice
}




const { pushSuccess, pushFail } = useNotifications()

const {
    addAdviceToStorage,
    removeAdviceFromStorage,
    removeAllSelectedAdvicesFromStorage,
    selectedAdvices,
    setInvoiceFormMode,
} = useAdviceDocuments()

const adviceDelivered = computed(() => props.advice.adviceStatus.symbol === 'delivered')
const adviceVerified = computed(() => props.advice.adviceStatus.symbol === 'verified')

const isAdviceCheckToInvoice = computed(() => {
    return selectedAdvices.value.map(e => e.id).indexOf(props.advice.id) > -1
})
const goToAdviceDetails = () => {
    router.push({ name: 'advice', params: { adviceId: props.advice.id } })
}

const onAdviceCheckChange = (checked: boolean, advice: Advice) => {
    if (checked) {
        setInvoiceFormMode(InvoiceFormModes.ADD)
        addAdviceToStorage(advice).then(() => {
            pushSuccess(`Zaznaczono zlecenie ${advice.axId}`)
        })
    } else {
        removeAdviceFromStorage(advice.id).then(() => {
            pushSuccess(`Odznaczono zlecenie ${advice.axId}`)
        })
    }
}
const onSingleInvoiceAdd = async (advice: Advice) => {
    await removeAllSelectedAdvicesFromStorage()
    await addAdviceToStorage(advice)
    router.push({ name: 'add-invoice' })
}

const hasInvoice = computed(() => props.advice.carrierInvoices.length !== 0)
const { downloadInvoice, isDownloadingInvoiceFile, deleteInvoice } = useInvoices()
const handleDownloadInvoice = (advice: Advice) => {
    const { id, filename, filenamePdf } = advice.carrierInvoices[0]
    downloadInvoice(id, filename || (filenamePdf && filenamePdf.split('.')[0]))
}

const onInvoiceDelete = async () => {
    try {
        await deleteInvoice(props.advice.carrierInvoices[0].id)
        emit('fetchAdvices')
        let successMessage = 'Usunięto fakturę'
        if (props.advice.carrierInvoices[0].number !== null) {
            successMessage += `o numerze: ${props.advice.carrierInvoices[0].number}`
        }
        pushSuccess(successMessage)
    } catch (error) {
        if (error instanceof Error) {
            pushFail(`Nie udało się usunąć faktury. ${error.message}`)
        }
    }
}

const getDropdownMenuItems = (): IDropdownMenuItem[] => {
    const menuItems: IDropdownMenuItem[] = [
        {
            label: 'Pokaż szczegóły',
            name: 'showDetails',
            handler: () => goToAdviceDetails(),
        },
    ]

    if (!hasInvoice.value && (adviceDelivered.value || adviceVerified.value)) {
        menuItems.push({
            label: 'Dodaj fakturę',
            name: 'addInvoice',
            handler: () => onSingleInvoiceAdd(props.advice),
        })
    }

    if (hasInvoice.value && props.advice.adviceStatus?.symbol === 'rejected') {
        menuItems.push({
            label: 'Usuń fakturę',
            name: 'deleteInvoice',
            handler: () => onInvoiceDelete(),
            confirmationClickRequired: true,
            confirmationQuestion:
                'Usunięcie faktury jest trwałe i nie można cofnąć tego procesu. Czy jesteś pewny/-a, że chcesz usunąć fakturę?',
        })
    }

    return menuItems
}

return (_ctx: any,_cache: any) => {
  const _component_IconDownload = _resolveComponent("IconDownload")!
  const _component_IconWheel = _resolveComponent("IconWheel")!
  const _component_IconTruck = _resolveComponent("IconTruck")!
  const _component_IconWeight = _resolveComponent("IconWeight")!

  return (_openBlock(), _createBlock(_unref(UiCard), {
    class: "transition-shadow duration-300 hover:shadow-lg",
    "custom-class": _unref(isAdviceCheckToInvoice) ? 'bg-blue-bg border-blue' : ''
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_unref(hasInvoice) && (_unref(adviceDelivered) || _unref(adviceVerified)))
            ? (_openBlock(), _createBlock(_unref(UiCheckbox), {
                key: 0,
                id: `adviceCheckbox${props.advice.id}`,
                modelValue: _unref(isAdviceCheckToInvoice),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isAdviceCheckToInvoice) ? (isAdviceCheckToInvoice).value = $event : null)),
                class: "mr-2",
                onChange: _cache[1] || (_cache[1] = checked => onAdviceCheckChange(checked, props.advice))
              }, null, 8, ["id", "modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(UiTitle), {
            class: "cursor-pointer hover:text-primary transition-colors duration-300",
            onClick: goToAdviceDetails
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.advice.axId), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(UiDotDivider), { class: "hidden lg:inline-block lg:mx-4" }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(props.advice.salesContract.number), 1),
            _createVNode(_unref(UiDotDivider), { class: "mx-4" }),
            _createElementVNode("span", _hoisted_5, _toDisplayString(props.advice.purchaseContract.number), 1)
          ]),
          _createVNode(_unref(UiDropdownMenu), {
            class: "ml-auto",
            items: getDropdownMenuItems()
          }, {
            "menu-button": _withCtx(() => [
              _createVNode(_unref(UiMenuDots))
            ]),
            _: 1
          }, 8, ["items"])
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(AdviceStatusLabel, {
            class: "mr-3",
            status: props.advice.adviceStatus
          }, null, 8, ["status"]),
          (_unref(hasInvoice))
            ? (_openBlock(), _createBlock(_unref(UiButton), {
                key: 0,
                loading: _unref(isDownloadingInvoiceFile),
                class: "flex items-center p-0 border-0",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleDownloadInvoice(props.advice)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconDownload, { class: "mr-1" }),
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(UiCardText), {
            class: "order-1",
            title: "Załadunek"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(props.advice.purchaseContract.supplier.name), 1),
              _createElementVNode("span", null, _toDisplayString(props.advice.supplierAdviceAddress?.postcode), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(props.advice.supplierAdviceAddress?.city), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(props.advice.supplierAdviceAddress?.address), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCardText), {
            class: "order-2",
            title: "Rozładunek"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(props.advice.salesContract.recipient.name), 1),
              _createElementVNode("span", null, _toDisplayString(props.advice.recipientAdviceAddress?.postcode), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(props.advice.recipientAdviceAddress?.city), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(props.advice.recipientAdviceAddress?.address), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCardText), {
            class: "order-3 lg:order-4",
            title: "Data załadunku",
            bold: true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.advice.loadingDate || '---'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCardText), {
            class: "order-4 lg:order-5",
            title: "Data rozładunku",
            bold: true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.advice.deliveryDate), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCardText), {
            class: "order-5 lg:order-3",
            title: "Transport"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UiCardIconText), null, {
                default: _withCtx(() => [
                  _createVNode(_component_IconWheel),
                  _createElementVNode("span", null, _toDisplayString(props.advice.driverFirstName) + " " + _toDisplayString(props.advice.driverLastName), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(UiCardIconText), null, {
                default: _withCtx(() => [
                  _createVNode(_component_IconTruck),
                  _createElementVNode("span", null, _toDisplayString(props.advice.vehicleIdentificationNumber), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(UiCardIconText), null, {
                default: _withCtx(() => [
                  _createVNode(_component_IconWeight),
                  _createElementVNode("span", null, _toDisplayString(props.advice.quantity) + " t", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (props.advice.amount)
            ? (_openBlock(), _createBlock(_unref(UiCardText), {
                key: 0,
                class: "order-6",
                title: "Koszt przewoźnika"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(props.advice.amount) + " " + _toDisplayString(props.advice.amountCurrency?.symbol), 1),
                  _createElementVNode("span", _hoisted_16, " stawka " + _toDisplayString(props.advice.transportRate) + " " + _toDisplayString(props.advice.amountCurrency?.symbol), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["custom-class"]))
}
}

})